import { StudentsFrequencyReport } from 'presentation/app/modules/Reports/pages/students/students-frequency-report';

export const MakeStudentsFrequencyReport: React.FC = () => {
  return <StudentsFrequencyReport />;
};
